/**
 * Created by saeed on 1/12/2017.
 */
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import {CacheUtilService} from "../cache-util/CacheUtilService";
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import {Observable} from 'rxjs/Rx';
import {
  API_URL_LOGIN,
  API_URL_SEND_ACTIVATION_CODE_TO_RESET_PASSWORD,
  API_URL_RESET_PASSWORD,
  API_URL_LOGOUT,
  API_URL_CONFIRM_ACTIVATION_CODE,
  API_URL_SEND_ACTIVATION_CODE,
  API_URL_LOGEDINUSER,
  API_URL_ACCOUNT,
  API_URL_REGISTER,
  API_URL_ACTIVATE_ACCOUNT,
  API_URL_REGEN_ACTIVATE_CODE,
  API_URL_GET_COMPANY_CUSTOMER_FOR_DATA_ENTRY_BY_COMPANY_ID,
  API_URL_SEND_ACTIVATION_CODE_BY_COMPANY,
  API_URL_SEND_ACTIVATION_CODE_TO_RESET_PASSWORD_BY_COMPANY, API_URL_REGISTER_WITH_PERSON_INFO
} from '../constants';
import {UserVM} from "../../models/UserVM";
import { Subject }    from 'rxjs/Subject';
import {BehaviorSubject} from 'rxjs/BehaviorSubject';
import {AlertService} from "../alert/alert.service";


import {BaseHttpService} from "../base-http-service";

//declare var Auth0Lock: any;
//declare var Auth0Lock: any;


@Injectable()
export class AuthService {
  public accountCachKey = "accountKey";
  public loggedInCachKey = "isLoggedIn";
  public lastAccountCheckDate="lastAccountCheckDate";
  public currentUser:UserVM = null;
  public isAuthenticated:boolean = false;


  constructor(private router:Router, private _cachUtil:CacheUtilService,
              private http:Http,
              private _http:BaseHttpService,
              private alertService:AlertService) {
this.updateLoginStatus();
  }

  login(credentials) {

    var data = {
      username: credentials.userName,
      password: credentials.password,
      rememberMe: credentials.rememberMe,
      captchaCode: credentials.captchaCode
    };

    return this._http.post(API_URL_LOGIN, data).toPromise();


  }


  /**
   * do log out
   * tell the server which current user is not log in
   * remove cached flags
   */
  logout(showToast = true) {
    let parent = this;
    // logout from the server
    //
    //this._http.get(API_URL_LOGOUT, null).subscribe(function (response) {
    //
    //});
    this.setAsLoggedout();
    if(showToast) parent.alertService.showInfoMessage('global.messages.info.SuccessfulLogout');

  }

  /**
   * return current user info and store it in cache
   * @returns {any}
   * @constructor
   */
  Account():Observable<any> {
    //
    let needToUpdateCache=false;
   if( this._cachUtil.exists(this.lastAccountCheckDate))
    {
      //also we can check the date and decide to update cache
      needToUpdateCache=false;
    }
    else
    {
      needToUpdateCache=true;
    }
    if (this._cachUtil.exists(this.accountCachKey) && !needToUpdateCache )
      return Observable.of(this._cachUtil.getFromCach(this.accountCachKey));
    else
      return this._http.get(API_URL_ACCOUNT)
        // ...and calling .json() on the response to return data
        .map((res:Response) => {
          this._cachUtil.storeInCache(this.accountCachKey, res);
          this._cachUtil.storeInCache(this.lastAccountCheckDate,new Date())
          return res;
        });

    //...errors if any
    //.catch((er);

  }

  /**
   * ask the server if current session is loggedin or not
   * @returns {any}
   */
  loggedIn() {
    return this._http.get(API_URL_LOGEDINUSER).toPromise();
  }

  /**
   * register user
   * @param registerAccount
   * @returns {any}
   */
  resetPassword(passwordDto:UserVM):any {
    return this._http.post(API_URL_RESET_PASSWORD, passwordDto).toPromise();
  }

  /**
   * register user
   * @param registerAccount
   * @returns {any}
   */
  createAccount(registerAccount:UserVM):any {
    return this.http.post(API_URL_REGISTER, registerAccount).toPromise();
  }

  /**
   * activate user by activation code
   * @param login
   * @param activationCode
   * @returns {any}
   */
  activateAccount(login:String, activationCode:String):any {
    return this.http.get(API_URL_ACTIVATE_ACCOUNT + '/' + login + '/' + activationCode).toPromise();
  }

  /***
   * regenerate the activation code and send it to user
   * @param login
   * @returns {any}
   */
  regenerateActivationCode(login:String):any {
    return this._http.get(API_URL_REGEN_ACTIVATE_CODE + '/' + login).toPromise();
  }


  sendActivationCode(phonenumber:String,keyUrl:String):any {
    // return this._http.get(API_URL_SEND_ACTIVATION_CODE + '/' + phonenumber).toPromise();
    return this._http.get(API_URL_SEND_ACTIVATION_CODE_BY_COMPANY + '/' + phonenumber + '/' + keyUrl).toPromise();
  }
  tryToSendActivationCode(phonenumber:String,keyUrl:String,onSuccess,onError):void {
    // this.http.get(API_URL_SEND_ACTIVATION_CODE + '/' + phonenumber)
    //   .subscribe((res:Response) => {onSuccess(res)},(error:any) => {onError(error);})
    this.http.get(API_URL_SEND_ACTIVATION_CODE_BY_COMPANY + '/' + phonenumber+ '/' + keyUrl)
      .subscribe((res:Response) => {onSuccess(res)},(error:any) => {onError(error);})


  }
  sendActivationCodeToResetPassword(phonenumber:String,keyUrl:String):any {
    // return this._http.get(API_URL_SEND_ACTIVATION_CODE_TO_RESET_PASSWORD + '/' + phonenumber).toPromise();
    return this._http.get(API_URL_SEND_ACTIVATION_CODE_TO_RESET_PASSWORD_BY_COMPANY + '/' + phonenumber+ '/' + keyUrl).toPromise();
  }

  confirmActivationCode(phonenumber:String, activationCode:String):any {
    return this._http.get(API_URL_CONFIRM_ACTIVATION_CODE + '/' + phonenumber + '/' + activationCode).toPromise();
  }


  /**
   * register user
   * @param registerAccount
   * @returns {any}
   */
  createAccountWithPersonInfo(registerAccount:UserVM):any {
    return this.http.post(API_URL_REGISTER_WITH_PERSON_INFO, registerAccount).toPromise();
  }

  /**
   * this method check if user is authenticated or not
   * @returns {boolean}
   */
  isLoggedIn() {
    //
    let isLoggeIn = this._cachUtil.getFromCach(this.loggedInCachKey);
    if (isLoggeIn != null && isLoggeIn != undefined) {
      return <boolean>isLoggeIn;
    }
    else {
      this.setAsLoggedout();
      return false;
    }

  }

  /**
   * this method persist the login flog for performance issue
   */
  setAsLoggedIn() {
    //setting the login flag in cache
    this._cachUtil.storeInCache(this.loggedInCachKey, true);
  }

  setAsLoggedout() {
    //setting the loggedIn flag in cache
    this._cachUtil.storeInCache(this.loggedInCachKey, false);
    //removing the user data from cache
    this._cachUtil.removeFromCache(this.accountCachKey);
    //removing jWT token
    this._cachUtil.removeFromCache('jhi-authenticationToken');
    this.isAuthenticated = false;
    this.currentUser = new UserVM();
  }

  updateLoginStatus(then?:any):void {


    let parent = this;
    this.isAuthenticated = false;
    this.currentUser = new UserVM();
    this.Account().subscribe((user)=> {
      if (user) {
        parent.isAuthenticated = true;
        parent.currentUser = user;
        this.setAsLoggedIn();
      }
      else
      {
        this.logout();
      }

      if(then)
        then();

    })

  }


}




// WEBPACK FOOTER //
// node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/services/auth/AuthService.ts